    $('.product-single__thumbnails-slider-trackk').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      focusOnSelect: true,
      swipeToSlide: true,
      swipe: true,
      infinite: true,
      speed: 300,
      draggable: false,
      focusOnChange: false,
      prevArrow: '<span class="recommended-prev-arrow"><i class="icon-arrow-left"></i></span>',
      nextArrow: '<span class="recommended-next-arrow"><i class="icon-arrow-right"></i></span>',
      responsive: [
        {
            breakpoint: 575,
             settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
               focusOnSelect: true,
               swipe: true,
               touchThreshold:100,
               variableWidth: false,
               focusOnChange: true,
               useTransform: false,
               initialSlide: 0,
               infinite:true
            }
        }
      ]
    });
    $('.recommendation-slider').slick({
        dots: true,
        infinite: false,
        speed: 400,
        autoplay: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: '<span class="recommended-prev-arrow"><i class="icon-arrow-left"></i></span>',
      nextArrow: '<span class="recommended-next-arrow"><i class="icon-arrow-right"></i></span>',
        responsive: [
            {
                breakpoint: 1535,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 575,
                settings: {
                        slidesToShow: 1
                }
            }
        ]
    });
    $(document).ready(function(){
        setTimeout(function(){
            let height = document.querySelector('.announcement-bar').offsetHeight;
            let main_height = document.querySelector('.main-header__section').offsetHeight;
                $('.main-content').css('padding-top', main_height);
            $(window).scroll(function(){
                if ($(this).scrollTop() > 170) {
                    $('.announcement-bar').css('margin-top', -height)
                   $('header.site-header').addClass('stickyHeader');
                } else {
                    $('.announcement-bar').css('margin-top', 0)
                   $('header.site-header').removeClass('stickyHeader');
                }
            });
        $('#SitePreloader-wrapper').addClass('loaded')
        $('.mega-menu').css("display", "block");
    }, 500);
    })

    $("#read__more").click(function() {
        $('html, body').animate({
            scrollTop: $("#read-more").offset().top
        }, 1000);
    });
    // $(document).ready(function() {
    //     $('.quantity_add.number .minus').click(function () {
    //       var $input = $(this).parent().find('input');
    //       var count = parseInt($input.val()) - 1;
    //       count = count < 1 ? 1 : count;
    //       $input.val(count);
    //       $input.change();
    //       return false;
    //     });
    //     $('.quantity_add.number .plus').click(function () {
    //       var $input = $(this).parent().find('input');
    //     //   if($input.val() < $input.attr('max')) {
    //         $input.val(parseInt($input.val()) + 1);
    //         $input.change();
    //     //   }
    //       return false;
    //     });
    //   });
      $(document).on('click', '.login-drawer-link', function(e){
        e.preventDefault();
        $('.login-drawer-wrapper').attr('aria-hidden', false);
        $('body,html').addClass('cart-drawer-isopen');
    });
    $('.login-drawer-wrapper, .cart-drawer--btn-close').click(function(e){
        if ($(e.target).is('.cart-drawer--wrapper') || $(this).is('.cart-drawer--btn-close')) {
        $('.login-drawer-wrapper').attr('aria-hidden', true);
        $('body,html').removeClass('cart-drawer-isopen');
        }
    });
    // $(document).ready(function(){
    //     setTimeout(function(){
    //     $('#SitePreloader-wrapper').addClass('loaded')
    //     $('.pr').removeClass('opacity_0')
    //     }, 3000);
    // })